'use client';

import { ReactNode } from 'react';

import { UiKitTagBase, UiKitTagBaseProps } from '@/fo/ui/kit/tag/base';
import { UiKitToggleBase } from '@/fo/ui/kit/toggle/base';

import { styles } from './UiKitTagToggle.styles';

export interface UiKitTagToggleProps extends UiKitTagBaseProps {
  children: ReactNode;
}

export function UiKitTagToggle({
  children,
  className,
  ...props
}: UiKitTagToggleProps) {
  const slots = styles();

  return (
    <UiKitTagBase
      className={slots.base({ className })}
      {...props}
    >
      {({ selected, disabled }) => (
        <div className={slots.container()}>
          <UiKitToggleBase
            as="div"
            checked={selected}
            disabled={disabled}
          />

          <div className={slots.text({ disabled })}>{children}</div>
        </div>
      )}
    </UiKitTagBase>
  );
}
